import { render, staticRenderFns } from "./TqChat_inputBar.vue?vue&type=template&id=16742e41&scoped=true&"
import script from "./TqChat_inputBar.vue?vue&type=script&lang=js&"
export * from "./TqChat_inputBar.vue?vue&type=script&lang=js&"
import style0 from "./TqChat_inputBar.vue?vue&type=style&index=0&id=16742e41&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16742e41",
  null
  
)

export default component.exports